import React from "react";

function VolumeUp() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={18}
            fill="none"
        >
            <path
                fill="#E3E3E3"
                d="M11 17.725v-2.05c1.5-.433 2.708-1.267 3.625-2.5.917-1.233 1.375-2.633 1.375-4.2 0-1.567-.458-2.967-1.375-4.2S12.5 2.708 11 2.275V.225c2.067.467 3.75 1.513 5.05 3.138C17.35 4.988 18 6.858 18 8.975s-.65 3.988-1.95 5.613c-1.3 1.624-2.983 2.67-5.05 3.137ZM0 12V6h4l5-5v16l-5-5H0Zm11 1V4.95a4.151 4.151 0 0 1 1.838 1.65c.441.733.662 1.533.662 2.4 0 .85-.22 1.637-.662 2.363A4.174 4.174 0 0 1 11 13ZM7 5.85 4.85 8H2v2h2.85L7 12.15v-6.3Z"
            />
        </svg>
    );
}

function VolumeDown() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={16}
            fill="none"
        >
            <path
                fill="#E3E3E3"
                d="M0 11V5h4l5-5v16l-5-5H0Zm11 1V3.95c.75.35 1.354.892 1.813 1.625.458.733.687 1.542.687 2.425 0 .883-.23 1.683-.688 2.4A4.251 4.251 0 0 1 11 12ZM7 4.85 4.85 7H2v2h2.85L7 11.15v-6.3Z"
            />
        </svg>
    );
}

function VolumeBelow() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={9}
            height={16}
            fill="none"
        >
            <path
                fill="#E3E3E3"
                d="M0 11V5h4l5-5v16l-5-5H0Zm2-2h2.85L7 11.15v-6.3L4.85 7H2v2Z"
            />
        </svg>
    );
}

function VolumeMute() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={21}
            height={21}
            fill="none"
        >
            <path
                fill="#E3E3E3"
                d="m18.8 20.6-3.025-3.025a8.306 8.306 0 0 1-1.325.688 9.48 9.48 0 0 1-1.45.462v-2.05c.233-.083.463-.167.688-.25.224-.083.437-.183.637-.3L11 12.8V18l-5-5H2V7h3.2L.4 2.2 1.8.8l18.4 18.4-1.4 1.4Zm-.2-5.8-1.45-1.45a6.796 6.796 0 0 0 .638-1.625c.141-.567.212-1.15.212-1.75 0-1.567-.458-2.967-1.375-4.2S14.5 3.708 13 3.275v-2.05c2.067.467 3.75 1.512 5.05 3.137C19.35 5.987 20 7.858 20 9.976c0 .883-.12 1.733-.363 2.55A8.803 8.803 0 0 1 18.6 14.8Zm-3.35-3.35L13 9.2V5.95a4.151 4.151 0 0 1 1.838 1.65c.441.733.662 1.533.662 2.4a4.33 4.33 0 0 1-.25 1.45ZM11 7.2 8.4 4.6 11 2v5.2Zm-2 5.95V10.8L7.2 9H4v2h2.85L9 13.15Z"
            />
        </svg>
    );
}

export { VolumeUp, VolumeDown, VolumeBelow, VolumeMute };
